/**
* ページ情報管理
*/

const actions = {
  /** ページ情報のセット */
  setShowFlag({ commit }, data) {
    commit('setShowFlag', data);
  },
};

const mutations = {
  setShowFlag(state, args) {
    const keys = Object.keys(state.showFlags);
    if (keys.includes(args.name) && typeof args.flag === 'boolean') state.showFlags[args.name] = args.flag;
  },
};

const state = {
  showFlags: {
    requests: false,
    orders: false,
    driverInfo: false,
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
